
import React from "react";

import iconTelefonia from './../../../assets/wp-content/uploads/2024/11/Finance-Line-Black-Converted_20.png'
import iconTeleMedicina from './../../../assets/wp-content/uploads/2024/11/batimento-cardiaco.png'
import iconConsorcio from './../../../assets/wp-content/uploads/2024/11/Finance-Line-Black-Converted_03.png'
import iconFranquias from './../../../assets/wp-content/uploads/2024/11/Finance-Line-Black-Converted_18.png'
import banner from './../../../assets/wp-content/uploads/2024/11/Sem-nome-700-x-700-px.png'
import banner2 from './../../../assets/wp-content/uploads/2024/11/Sem-nome-700-x-700-px-300x300.png'
import banner3 from './../../../assets/wp-content/uploads/2024/11/Sem-nome-700-x-700-px-150x150.png'

class SectionBenefities extends React.Component{
    render(){
        return(

            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-727c0485 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="727c0485"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-7272e695"
                  data-id="7272e695"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <section
                      className="elementor-section elementor-inner-section elementor-element elementor-element-3cd888b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                      data-id="3cd888b3"
                      data-element_type="section"
                    >
                      <div className="elementor-container elementor-column-gap-default">
                        <div
                          className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-6bc0308"
                          data-id="6bc0308"
                          data-element_type="column"
                        >
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div
                              className="elementor-element elementor-element-179c8aba elementor-position-top elementor-widget elementor-widget-image-box"
                              data-id="179c8aba"
                              data-element_type="widget"
                              data-widget_type="image-box.default"
                            >
                              <div className="elementor-widget-container">
                                <div className="elementor-image-box-wrapper">
                                  <figure className="elementor-image-box-img">
                                    <img
                                      decoding="async"
                                      width="91"
                                      height="94"
                                      src={iconTelefonia}
                                      className="elementor-animation-grow attachment-full size-full wp-image-18"
                                      alt=""
                                    />
                                  </figure>
                                  <div className="elementor-image-box-content">
                                    <h5 className="elementor-image-box-title">
                                      Telefonia
                                    </h5>
                                    <p className="elementor-image-box-description">
                                      Conectividade e eficiência para
                                      impulsionar seus negócios.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-69493e07 elementor-position-top elementor-widget elementor-widget-image-box"
                              data-id="69493e07"
                              data-element_type="widget"
                              data-widget_type="image-box.default"
                            >
                              <div className="elementor-widget-container">
                                <div className="elementor-image-box-wrapper">
                                  <figure className="elementor-image-box-img">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width="128"
                                      height="128"
                                      src={iconTeleMedicina}
                                      className="elementor-animation-grow attachment-full size-full wp-image-47"
                                      alt=""
                                    />
                                  </figure>
                                  <div className="elementor-image-box-content">
                                    <h5 className="elementor-image-box-title">
                                      Tele Medicina
                                    </h5>
                                    <p className="elementor-image-box-description">
                                      Praticidade e qualidade na sua saúde,
                                      direto de casa.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-b2eef06"
                          data-id="b2eef06"
                          data-element_type="column"
                        >
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div
                              className="elementor-element elementor-element-4fc4477e elementor-position-top elementor-widget elementor-widget-image-box"
                              data-id="4fc4477e"
                              data-element_type="widget"
                              data-widget_type="image-box.default"
                            >
                              <div className="elementor-widget-container">
                                <div className="elementor-image-box-wrapper">
                                  <figure className="elementor-image-box-img">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width="94"
                                      height="93"
                                      src={iconConsorcio}
                                      className="elementor-animation-grow attachment-full size-full wp-image-20"
                                      alt=""
                                    />
                                  </figure>
                                  <div className="elementor-image-box-content">
                                    <h5 className="elementor-image-box-title">
                                      Consórcio
                                    </h5>
                                    <p className="elementor-image-box-description">
                                      Conquiste bens de alto valor com
                                      planejamento e acessibilidade.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="elementor-element elementor-element-ec8b755 elementor-position-top elementor-widget elementor-widget-image-box"
                              data-id="ec8b755"
                              data-element_type="widget"
                              data-widget_type="image-box.default"
                            >
                              <div className="elementor-widget-container">
                                <div className="elementor-image-box-wrapper">
                                  <figure className="elementor-image-box-img">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width="94"
                                      height="94"
                                      src={iconFranquias}
                                      className="elementor-animation-grow attachment-full size-full wp-image-21"
                                      alt=""
                                    />
                                  </figure>
                                  <div className="elementor-image-box-content">
                                    <h5 className="elementor-image-box-title">
                                      Franquias
                                    </h5>
                                    <p className="elementor-image-box-description">
                                      Expanda no mercado com negócios
                                      comprovados.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
                <div
                  className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-408dd38b"
                  data-id="408dd38b"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-16770e21 elementor-widget elementor-widget-image"
                      data-id="16770e21"
                      data-element_type="widget"
                      data-widget_type="image.default"
                    >
                      <div className="elementor-widget-container">
                        <img
                          loading="lazy"
                          decoding="async"
                          width="700"
                          height="700"
                          src={banner}
                          className="attachment-large size-large wp-image-45"
                          alt=""
                          srcSet={`
                            ${banner}  700w,
                            ${banner2} 300w
                            ${banner3} 150w
                          `}
                          sizes="(max-width: 700px) 100vw, 700px"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
        );
    }
}
export default SectionBenefities;